import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PushSpinner } from "react-spinners-kit";

function BaseLoader() {
  return (
    <div className="loader-container flex items-center justify-center h-full bg-white">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-ternary sm:pl-6 transition ease-in-out duration-700">
              <PushSpinner size={40} color="var(--theme_color)" />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BaseLoader);
